<template>
  <v-container fluid class="homepage-dev-container">
    <DevHeader />

    <v-row class="homepage-dev">
      <v-col sm="12" class="pl-6 pr-0 text-center">
        <h1 class="text-h3 grey--text text--darken-3 font-weight-bold">
          Desenvolvimento
          <span>Portal</span>
        </h1>

        <p class="mb-10 font-weight-regular text-body-1 grey--text text--darken-3">
          Bem-vindo a ferramenta de desenvolvimento do portal I4PRO.
          <br />Com ela vamos poder configurar o visual, menus, criar e editar <br />suas telas de uma maneira simples.
        </p>

        <v-btn
          href="http://jarvis/I4Pro/PD/_wiki/wikis/Portal"
          target="_blank"
          x-large
          color="#f85601"
          dark
          elevation="0"
        >
          <v-icon class="mr-2">library_books</v-icon>Documentação
        </v-btn>
      </v-col>

      <v-col class="card-navigation__wrapper">
        <v-card
          @click="handleLoadTemplate('templateMenu')"
          class="card-navigation mr-6"
          :disabled="selectedModule"
          elevation="0"
        >
          <v-img src="static/svg/dev-icon-menu.svg" alt="Imagem de Menus" />

          <h3 class="font-weight-bold text-subtitle-1 grey--text text--darken-3">Menus</h3>
        </v-card>

        <v-card
          @click="handleLoadTemplate('templateLayoutConfig')"
          class="card-navigation mr-6"
          :disabled="selectedPortal"
          elevation="0"
        >
          <v-img src="static/svg/dev-icon-layout.svg" alt="Imagem de Layout" />

          <h3 class="font-weight-bold text-subtitle-1 grey--text text--darken-3">Layout</h3>
        </v-card>

        <v-card
          @click="handleLoadTemplate('templatePage')"
          class="card-navigation mr-6"
          :disabled="selectedModule"
          elevation="0"
        >
          <v-img src="static/svg/dev-icon-page.svg" alt="Imagem de Páginas" />

          <h3 class="font-weight-bold text-subtitle-1 grey--text text--darken-3">Páginas</h3>
        </v-card>

        <v-card
          @click="handleLoadTemplate('templateModule')"
          class="card-navigation"
          :disabled="selectedEnvironment"
          elevation="0"
        >
          <v-img src="static/svg/dev-icon-module.svg" alt="Imagem de Módulos" />

          <h3 class="font-weight-bold text-subtitle-1 grey--text text--darken-3">Módulos</h3>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  components: {
    DevHeader: () => import('@/components/dev/dev-header')
  },

  computed: {
    selectedPortal() {
      let ret = this.$store.getters['dev/getSelectedPortal'];

      return ret ? false : true;
    },

    selectedModule() {
      let ret = this.$store.getters['dev/getSelectedModule'];

      return ret ? false : true;
    },

    selectedEnvironment() {
      let ret = this.$store.getters['dev/getSelectedEnvironment'];

      return ret ? false : true;
    },

    pathDocs() {
      return `${window.location.origin}${window.location.pathname}Docs`;
    }
  },

  methods: {
    handleLoadTemplate(param) {
      this.$store.dispatch('dev/setCurrentTemplate', param);
    }
  }
};
</script>
